module.exports = __webpack_public_path__ + "img/1.b376c0ec.jpeg";